import React from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import CustomerList from './CustomerList';

const Customer = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title='Listado Clientes' pageTitle='Clientes' />
                <CustomerList />
            </div>
        </React.Fragment>
    )
}

export default Customer;